const DEFAULT_VALUE = JSON.stringify(null);

let localStorage = {
  getItem: (key) => localStorage[key],
  setItem: (key, value) => (localStorage[key] = value),
};
try {
  if (process.browser) {
    localStorage = window.localStorage;
    localStorage.debug = 'y*';
  }
} catch (e) {
  console.log(e);
}

class LocalStorage {
  constructor() {
    this.recentFont = null;
  }

  getItem = (key) => {
    const value = localStorage.getItem(key);
    return JSON.parse(value || DEFAULT_VALUE);
  };

  setItem = (key, value) => {
    return localStorage.setItem(key, JSON.stringify(value));
  };

  get favoriteFonts() {
    return this.getItem('favoriteFonts');
  }

  set favoriteFonts(value) {
    this.setItem('favoriteFonts', value);
  }

  get userProfile() {
    return this.getItem('userProfile');
  }

  set userProfile(value) {
    this.setItem('userProfile', value);
  }

  get language() {
    return this.getItem('language');
  }

  set language(value) {
    this.setItem('language', value);
  }

  get recommendedIllusts() {
    return this.getItem('recommendedIllusts');
  }

  set recommendedIllusts(value) {
    this.setItem('recommendedIllusts', value);
  }

  get matterialPatterns() {
    return this.getItem('matterialPatterns');
  }

  set matterialPatterns(value) {
    this.setItem('matterialPatterns', value);
  }

  get aiUsage() {
    return this.getItem('aiUsage') || {};
  }

  set aiUsage(value) {
    this.setItem('aiUsage', value);
  }

  get uploadedSkies() {
    return this.getItem('uploadedSkies') || [];
  }

  set uploadedSkies(value) {
    this.setItem('uploadedSkies', value);
  }

  get firstUsage() {
    return this.getItem('firstUsage') || '1ST';
  }

  set firstUsage(value) {
    this.setItem('firstUsage', value);
  }

  get recentColors() {
    return this.getItem('recentColors') || [];
  }

  set recentColors(value) {
    this.setItem('recentColors', value);
  }

  get colorEyeDropperMode() {
    return this.getItem('colorEyeDropperMode') || 'fill';
  }

  set colorEyeDropperMode(value) {
    this.setItem('colorEyeDropperMode', value);
  }

  get saveDesignInterval() {
    return this.getItem('saveDesignInterval') || null;
  }

  set saveDesignInterval(value) {
    this.setItem('saveDesignInterval', value);
  }

  get firstDesignSave() {
    return this.getItem('firstDesignSave') || false;
  }

  set firstDesignSave(value) {
    this.setItem('firstDesignSave', value);
  }

  get collabUsersSelection() {
    return this.getItem('collabUsersSelection') || [];
  }

  set collabUsersSelection(value) {
    this.setItem('collabUsersSelection', value);
  }

  get syncPageInterval() {
    return this.getItem('syncPageInterval') || null;
  }

  set syncPageInterval(value) {
    this.setItem('syncPageInterval', value);
  }

  get saveTemplateInterval() {
    return this.getItem('saveTemplateInterval') || null;
  }

  set saveTemplateInterval(value) {
    this.setItem('saveTemplateInterval', value);
  }

  get atenaSenderPostcodePosition() {
    return this.getItem('atenaSenderPostcodePosition') || {};
  }

  set atenaSenderPostcodePosition(value) {
    this.setItem('atenaSenderPostcodePosition', value);
  }

  get atenaSenderInfoVerticalPosition() {
    return this.getItem('atenaSenderInfoVerticalPosition') || {};
  }

  set atenaSenderInfoVerticalPosition(value) {
    this.setItem('atenaSenderInfoVerticalPosition', value);
  }

  get atenaSenderInfoHorizontalPosition() {
    return this.getItem('atenaSenderInfoHorizontalPosition') || {};
  }

  set atenaSenderInfoHorizontalPosition(value) {
    this.setItem('atenaSenderInfoHorizontalPosition', value);
  }

  get atenaReceiverPostcodePosition() {
    return this.getItem('atenaReceiverPostcodePosition') || {};
  }

  set atenaReceiverPostcodePosition(value) {
    this.setItem('atenaReceiverPostcodePosition', value);
  }

  get atenaCurrentReceiver() {
    return this.getItem('atenaCurrentReceiver') || {};
  }

  set atenaCurrentReceiver(value) {
    this.setItem('atenaCurrentReceiver', value);
  }

  get atenaCurrentSender() {
    return this.getItem('atenaCurrentSender') || {};
  }

  set atenaCurrentSender(value) {
    this.setItem('atenaCurrentSender', value);
  }

  get atenaCurrentReceiverPostalCode() {
    return this.getItem('atenaCurrentReceiverPostalCode') || {};
  }

  set atenaCurrentReceiverPostalCode(value) {
    this.setItem('atenaCurrentReceiverPostalCode', value);
  }

  get atenaCurrentSenderPostalCode() {
    return this.getItem('atenaCurrentSenderPostalCode') || {};
  }

  set atenaCurrentSenderPostalCode(value) {
    this.setItem('atenaCurrentSenderPostalCode', value);
  }

  set atenaCurrentReceiverPostalCodeFirstImport(value) {
    this.setItem('atenaCurrentReceiverPostalCodeFirstImport', value);
  }

  get atenaCurrentReceiverPostalCodeFirstImport() {
    return this.getItem('atenaCurrentReceiverPostalCodeFirstImport') || false;
  }

  set atenaCurrentSenderPostalCodeFirstImport(value) {
    this.setItem('atenaCurrentSenderPostalCodeFirstImport', value);
  }

  get atenaCurrentSenderPostalCodeFirstImport() {
    return this.getItem('atenaCurrentSenderPostalCodeFirstImport') || false;
  }

  get displayMaskGuideline() {
    return this.getItem('displayMaskGuideline') || false;
  }

  set displayMaskGuideline(value) {
    this.setItem('displayMaskGuideline', value);
  }

  get displayFrameGuideline() {
    return this.getItem('displayFrameGuideline') || false;
  }

  set displayFrameGuideline(value) {
    this.setItem('displayFrameGuideline', value);
  }

  get recentFont() {
    return this.getItem('recentFont') || null;
  }

  set recentFont(value) {
    this.setItem('recentFont', value);
  }

  set atenaReceiversPostionVertical(value) {
    this.setItem('atenaReceiversPostionVertical', value);
  }

  get atenaReceiversPostionVertical() {
    return this.getItem('atenaReceiversPostionVertical') || null;
  }

  set atenaReceiversPostionHorizontal(value) {
    this.setItem('atenaReceiversPostionHorizontal', value);
  }

  get atenaReceiversPostionHorizontal() {
    return this.getItem('atenaReceiversPostionHorizontal') || null;
  }

  get isShowModalNotificationFeebackMypage() {
    return this.getItem('isShowModalNotificationFeebackMypage') || null;
  }

  set isShowModalNotificationFeebackMypage(value) {
    this.setItem('isShowModalNotificationFeebackMypage', value);
  }

  get isShowTourGuideCollab() {
    return this.getItem('isShowTourGuideCollab') || null;
  }
  set isShowTourGuideCollab(value) {
    this.setItem('isShowTourGuideCollab', value);
  }
}

export default new LocalStorage();
